module.exports = __webpack_public_path__ + "static/media/02zhanwuyuan.1835882b.png";